import { Component, OnInit, Input, HostBinding } from '@angular/core';
import {ChartType} from './chart/model/chart-type.model';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss']
})
export class ChartsComponent implements OnInit {

  @Input() width: string;

  public readonly TYPE : ChartType = ChartType;

  constructor() {

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/charts/charts.component.ts